import type { OrderStatus, TripStatus } from '@kmdx/contracts';

/**
 * Машината на състоянията на заявката — същата като в docs/DOMAIN.md.
 * Сървърът е авторитетът; тук държим същата таблица, за да не показваме бутон,
 * който ще получи отказ. Ако сървърът върне свой списък, той печели.
 */
export const ORDER_TRANSITIONS: Record<OrderStatus, OrderStatus[]> = {
  draft: ['confirmed', 'cancelled'],
  confirmed: ['planned', 'cancelled'],
  planned: ['assigned', 'loaded', 'in_progress', 'cancelled'],
  assigned: ['loaded', 'in_progress', 'cancelled'],
  loaded: ['in_progress', 'delivered', 'cancelled'],
  in_progress: ['delivered', 'cancelled'],
  delivered: ['documents_pending', 'ready_to_invoice'],
  documents_pending: ['ready_to_invoice'],
  /* „Фактурирана" идва от издадената фактура, не от бутон. */
  ready_to_invoice: [],
  /* „Платена" не е бутон — идва от плащането по фактурата. */
  invoiced: ['closed'],
  paid: ['closed'],
  closed: [],
  cancelled: [],
};

/** Текстът на бутона, не името на състоянието: „Потвърди", не „Потвърдена". */
export const ORDER_TRANSITION_LABEL: Record<OrderStatus, string> = {
  draft: 'Върни в чернова',
  confirmed: 'Потвърди заявката',
  planned: 'Отбележи като планирана',
  assigned: 'Отбележи като възложена',
  loaded: 'Отбележи като натоварена',
  in_progress: 'Отбележи като тръгнала',
  delivered: 'Отбележи като доставена',
  documents_pending: 'Липсват документи',
  ready_to_invoice: 'Готова за фактуриране',
  invoiced: 'Фактурирана',
  paid: 'Платена',
  closed: 'Приключи',
  cancelled: 'Анулирай',
};

export function allowedOrderTransitions(
  status: OrderStatus,
  fromServer?: OrderStatus[] | undefined,
): OrderStatus[] {
  return fromServer ?? ORDER_TRANSITIONS[status];
}

/** Преходи, за които се иска потвърждение — необратими или скъпи. */
export const ORDER_TRANSITION_NEEDS_REASON: OrderStatus[] = ['cancelled'];

export const ORDER_STATUS_TONE: Record<
  OrderStatus,
  'neutral' | 'info' | 'accent' | 'ok' | 'warn' | 'danger'
> = {
  draft: 'neutral',
  confirmed: 'info',
  planned: 'info',
  assigned: 'info',
  loaded: 'accent',
  in_progress: 'accent',
  delivered: 'ok',
  documents_pending: 'warn',
  ready_to_invoice: 'ok',
  invoiced: 'ok',
  paid: 'ok',
  closed: 'neutral',
  cancelled: 'danger',
};

export const TRIP_STATUS_TONE: Record<
  TripStatus,
  'neutral' | 'info' | 'accent' | 'ok' | 'warn' | 'danger'
> = {
  draft: 'neutral',
  planned: 'info',
  // Изпратен, но още неприет — това е разликата, която бордът не бива да крие.
  dispatched: 'warn',
  accepted: 'info',
  in_progress: 'accent',
  completed: 'ok',
  cancelled: 'danger',
};

/** Заявките, които чакат бус — те са работата на диспечера за деня. */
export const ORDERS_AWAITING_DISPATCH: OrderStatus[] = ['confirmed'];
